import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box, Button, Paper, Typography } from '@material-ui/core'
import { formatPrice } from '../../utils/helpers'
import theme from '../../utils/theme'

const BetTotalBase = styled(Paper)`
  position: relative;
  ${theme.breakpoints.up('sm')} {
    padding: ${props => props.theme.spacing(3)}px
      ${props => props.theme.spacing(4)}px;
    margin: ${props => props.theme.spacing(3)}px;
    margin-top: ${props => props.theme.spacing(10)}px;
  }
  ${theme.breakpoints.down('sm')} {
    padding: ${props => props.theme.spacing(4)}px;
    border-radius: 4px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
`

const BetTotals = props => {
  const { bets, multiBets, loading, isUserLoggedIn, handlePlaceBet } = props

  const straightStake = multiBets.straight.stake || 0
  const straightOdds = multiBets.straight.odds || 0
  const straightReturns = straightStake * straightOdds

  const totalStake = Object.keys(bets).reduce((total, index) => {
    const bet = bets[index]
    if (!bet.stake) {
      return total
    }
    return total + bet.stake
  }, 0)

  const totalReturns = Object.keys(bets).reduce((total, index) => {
    const bet = bets[index]
    if (!bet.returns) {
      return total
    }
    return total + bet.returns
  }, 0)

  return (
    <BetTotalBase>
      <Box display="flex" width={1} mb={1}>
        <Typography variant="body1" color="textSecondary">
          Total Stake:
        </Typography>
        <Box ml="auto">
          <Typography variant="subtitle1" color="textPrimary">
            {formatPrice(straightStake * 100 + totalStake * 100)}
          </Typography>
        </Box>
      </Box>
      <Box display="flex" width={1} mb={3}>
        <Typography variant="body1" color="textSecondary">
          Total Returns:
        </Typography>
        <Box ml="auto">
          <Typography variant="subtitle1" color="textPrimary">
            {formatPrice(straightReturns * 100 + totalReturns * 100)}
          </Typography>
        </Box>
      </Box>
      <Button
        disabled={loading || !isUserLoggedIn || !(totalStake + straightReturns)}
        variant="contained"
        color="primary"
        onClick={() => handlePlaceBet(parseFloat(totalStake + straightStake))}
        fullWidth
      >
        {isUserLoggedIn && (
          <span>
            Place Bet {formatPrice(straightStake * 100 + totalStake * 100)}
          </span>
        )}
        {!isUserLoggedIn && <span>Please log in</span>}
      </Button>
    </BetTotalBase>
  )
}

BetTotals.propTypes = {
  bets: PropTypes.object,
  multiBets: PropTypes.object,
  loading: PropTypes.bool,
  isUserLoggedIn: PropTypes.bool,
  handlePlaceBet: PropTypes.func,
}

export default BetTotals
